import React from 'react';
import { Card } from '../components/UI/Card';
import { Button } from '../components/UI/Button';
import { Link } from 'react-router-dom';
interface FAQProps {
  openRegistrationForm?: () => void;
}
export const FAQ = ({
  openRegistrationForm
}: FAQProps) => {
  const faqSections = [{
    title: '🌍 For Visitors',
    questions: [{
      question: 'What is The Networking Salon?',
      answer: 'The Networking Salon is a community designed for culture shapers, leaders, influencers, and professionals who want to grow, collaborate, and make meaningful connections. We provide resources, curated opportunities, and interactive spaces to build authentic networks.'
    }, {
      question: 'Who can join the community?',
      answer: "Our community is open to professionals, entrepreneurs, creatives, and leaders who are curious, impact-driven, and ready to collaborate. Whether you're just starting out or already established, you'll find tools, peers, and opportunities to grow."
    }, {
      question: 'Is the community free to join?',
      answer: "No. The Networking Salon is a curated membership community. Interested individuals must apply to join. If approved, you'll receive details regarding membership plans and payment.",
      hasButton: true
    }, {
      question: 'What is the membership application process?',
      answer: <div data-id="element-2437">
              <p data-id="element-2438">The process is simple:</p>
              <ul className="list-disc list-inside mt-2 space-y-1" data-id="element-2439">
                <li data-id="element-2440">
                  <strong data-id="element-2441">Apply</strong> → Submit an application form.
                </li>
                <li data-id="element-2442">
                  <strong data-id="element-2443">Review</strong> → Our team evaluates your fit with the
                  community's vision.
                </li>
                <li data-id="element-2444">
                  <strong data-id="element-2445">Approval</strong> → If approved, you'll receive
                  membership details.
                </li>
                <li data-id="element-2446">
                  <strong data-id="element-2447">Payment</strong> → Secure your spot by completing
                  payment.
                </li>
                <li data-id="element-2448">
                  <strong data-id="element-2449">Onboarding</strong> → Get access to resources, the
                  directory, and events.
                </li>
              </ul>
            </div>,
      hasButton: true
    }, {
      question: 'What kind of resources do you offer?',
      answer: <div data-id="element-2450">
              <p data-id="element-2451">We've built practical, ready-to-use resources, including:</p>
              <ul className="list-disc list-inside mt-2 space-y-1" data-id="element-2452">
                <li data-id="element-2453">
                  🚀 LinkedIn Optimization Checklist – strengthen your
                  professional visibility.
                </li>
                <li data-id="element-2454">
                  🤝 Networking Scripts & Templates – easy outreach and
                  follow-up examples.
                </li>
                <li data-id="element-2455">
                  🌏 Opportunity Tracker – keep tabs on grants, fellowships, and
                  funding.
                </li>
                <li data-id="element-2456">
                  🎙 Podcast Starter List – curated content to sharpen skills
                  and mindset.
                </li>
                <li data-id="element-2457">
                  ❤️ Community Culture Tools – frameworks for collaboration and
                  mentorship.
                </li>
                <li data-id="element-2458">
                  📒 Community Directory – connect with members based on skills
                  and interests.
                </li>
              </ul>
            </div>
    }]
  }, {
    title: '✨ For New Members',
    questions: [{
      question: 'How do I get started once I join?',
      answer: <ul className="list-disc list-inside space-y-1" data-id="element-2459">
              <li data-id="element-2460">Complete your member profile in the Community Directory.</li>
              <li data-id="element-2461">
                Explore the Networking Guide to design your networking approach.
              </li>
              <li data-id="element-2462">Check the Opportunity Tracker and Scholarship Database.</li>
              <li data-id="element-2463">
                Attend an onboarding session (virtual) to meet other new
                members.
              </li>
            </ul>
    }, {
      question: 'How do I connect with other members?',
      answer: <div data-id="element-2464">
              <p data-id="element-2465">You can connect through:</p>
              <ul className="list-disc list-inside mt-2 space-y-1" data-id="element-2466">
                <li data-id="element-2467">
                  The Community Directory (searchable by skills, interests, and
                  location).
                </li>
                <li data-id="element-2468">
                  Peer-to-peer Networking Sessions (scheduled via Calendly).
                </li>
                <li data-id="element-2469">Collaboration Playbooks and group projects.</li>
                <li data-id="element-2470">Events, both virtual and in-person.</li>
              </ul>
            </div>
    }, {
      question: "I'm new to networking. Where should I start?",
      answer: <div data-id="element-2471">
              <p data-id="element-2472">
                Start with our Networking Guide — an interactive workbook that
                helps you design your own approach, build confidence, and track
                progress. Pair it with the Networking Scripts to make first
                outreach easier.
              </p>
              <div className="mt-4" data-id="element-2473">
                <Link to="/networking-guide" data-id="element-2474">
                  <Button variant="outline" data-id="element-2475">View Networking Guide</Button>
                </Link>
              </div>
            </div>
    }]
  }, {
    title: '🌱 For Active Members',
    questions: [{
      question: 'How do I use the Notion templates?',
      answer: "We provide shareable Notion templates that you can duplicate into your own workspace with a single click. You'll find trackers, databases, and interactive workbooks (like the Networking Guide)."
    }, {
      question: 'Can I contribute resources to the community?',
      answer: 'Yes! We welcome member contributions — from opportunities, guides, and case studies to hosting workshops. Collaboration is at the heart of the Networking Salon.'
    }, {
      question: 'Do you host events?',
      answer: 'Yes! We organize virtual meetups, workshops, and city-based gatherings (e.g., Lagos, Abuja, Berlin, Benin City, Delta). Members can also host their own events through our collaboration framework.'
    }, {
      question: 'How do I stay updated?',
      answer: <ul className="list-disc list-inside space-y-1" data-id="element-2476">
              <li data-id="element-2477">Subscribe to our community mailing list.</li>
              <li data-id="element-2478">Check the Opportunity Tracker regularly.</li>
              <li data-id="element-2479">Follow updates inside the community hub.</li>
            </ul>
    }]
  }];
  return <div className="pt-20" data-id="element-2480">
      <section className="py-16 bg-secondary/5" data-id="element-2481">
        <div className="container mx-auto px-4" data-id="element-2482">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-2483">
            ❓ Frequently Asked Questions (FAQ)
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-2484">
            Find answers to common questions about The Networking Salon,
            membership, and how to make the most of our community.
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-2485">
        <div className="container mx-auto px-4" data-id="element-2486">
          <div className="space-y-12" data-id="element-2487">
            {faqSections.map((section, sectionIndex) => <div key={sectionIndex} data-id="element-2488">
                <h2 className="text-2xl font-bold text-secondary-dark mb-6" data-id="element-2489">
                  {section.title}
                </h2>
                <div className="space-y-6" data-id="element-2490">
                  {section.questions.map((faq, faqIndex) => <Card key={faqIndex} className="p-6" data-id="element-2491">
                      <h3 className="text-xl font-bold text-secondary-dark mb-3" data-id="element-2492">
                        {faqIndex + 1}. {faq.question}
                      </h3>
                      <div className="text-secondary" data-id="element-2493">{faq.answer}</div>
                      {faq.hasButton && <div className="mt-4" data-id="element-2494">
                          <Button onClick={openRegistrationForm} data-id="element-2495">
                            Apply Now
                          </Button>
                        </div>}
                    </Card>)}
                </div>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
};